import React from "react";
import { IBanner } from "../../../app/models/banner";
import { observer } from "mobx-react-lite";
import { Image, Table } from "semantic-ui-react";
import { Link } from "react-router-dom";

const BannerListItem: React.FC<{ banner: IBanner }> = ({ banner }) => {
  return (
    <Table.Row>
      <Table.Cell>
        <Link to={`/admin/banners/${banner.id}`}>
          {banner.code === "DASHBOARD" && "Página inicial"}
          {banner.code === "QUESTION" && "Página de questões"}
          {banner.code === "POPUP1QUESTION" && "Popup 1 da Questão"}
          {banner.code === "POPUP2QUESTION" && "Popup 2 da Questão"}
        </Link>
      </Table.Cell>
      <Table.Cell>
        <Image
          src={banner.url}
          style={{
            height: "100%",
            width: "100%",
            objectFit: "contain",
          }}
        />
      </Table.Cell>
      <Table.Cell>
        <a href={banner.redirectUrl} target="_blank" rel="noopener noreferrer">
          {banner.redirectUrl}
        </a>
      </Table.Cell>
    </Table.Row>
  );
};

export default observer(BannerListItem);
